export const DEFAULT_APP_NAME = 'in-meeting-experience-ui-components';